import { render } from "./BackgroundVideoParallax.vue?vue&type=template&id=64b92d86&scoped=true"
import script from "./BackgroundVideoParallax.vue?vue&type=script&lang=js"
export * from "./BackgroundVideoParallax.vue?vue&type=script&lang=js"

import "./BackgroundVideoParallax.vue?vue&type=style&index=0&id=64b92d86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b92d86"]])

export default __exports__